<template lang="pug">
div
  div(v-if="media.length")
    light-box(ref="lightBox", :media="media", :showLightBox="false")
  .s-rounded
    .columns
      .column.col-auto
        user-avatar(:user="comentario.usuario || {}")
      .column.py-2.bg-gray.height-100.d-flex.flex-vertical
        .align-center.flex-1.text-long
          | {{ comentario.descricao }}
        .columns.mt-2
          .column.col-auto.my-1(v-for="(anexo, index) in comentario.anexos")
            .card
              .card-image.flex-1
                img.s-rounded.img-responsive.anexo(
                  :src="anexo.thumb",
                  @click="openImage(index)"
                )
                .text-right(v-if="anexo.geolocation")
                  button.btn.btn-link(@click="openMap(anexo)")
                    i.fa.fa-map-pin
        .text-small.columns.pt-2
          .column.col-auto
            .abbr {{ "comentario.usuario" | tModel }}
            cite(v-if="comentario.usuario") {{ comentario.usuario.nome }}
          .column.col-auto
            .abbr {{ "comentario.realizado_em" | tModel }}
            cite {{ comentario.realizado_em | date }}
          .column
          .column.col-auto
            .abbr {{ "comentario.created_at" | tModel }}
            cite {{ comentario.created_at | date }}
  foto-map-modal(
    :active="showMap",
    title="Mapa do local da foto",
    :foto="fotoMap",
    @close="closeMap()"
  )
</template>

<script>
export default {
  props: { comentario: { type: Object, required: true } },
  data() {
    return { showMap: false, fotoMap: null }
  },
  computed: {
    media() {
      return this.comentario.anexos.map((anexo) => ({
        thumb: anexo.thumb,
        src: anexo.file_ext === "pdf" ? anexo.thumb : anexo.url,
      }))
    },
  },
  methods: {
    openMap(anexo) {
      if (!anexo || !anexo.geolocation) return
      this.fotoMap = anexo
      this.showMap = true
    },
    closeMap() {
      this.showMap = false
      this.fotoMap = null
    },
    openImage(index) {
      if (this.comentario.anexos[index].file_ext === "pdf") {
        window.open(this.comentario.anexos[index].url)
      } else {
        this.$refs.lightBox.showImage(index)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.height-100 {
  height: 100%;
}

.anexo {
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.07);
  }
}

.flex-vertical {
  flex-direction: column;
}

.flex-1 {
  flex: 1;
}
</style>
